import { createApi } from '@shared/redux/createApi';

const tags = {
  getBalance: 'getBalance',
};
export const balanceApi = createApi({
  reducerPath: 'balanceApi',
  tagTypes: [tags.getBalance],

  endpoints: (builder) => ({
    getBalance: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/main_account_balance`,
        });
      },
      providesTags: [tags.getBalance],
    }),
  }),
});

export const { useGetBalanceQuery } = balanceApi;